var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    style: {
      color: "#f65050"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.167 10a5.833 5.833 0 1 0 11.666 0 5.833 5.833 0 0 0-11.666 0ZM10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm0 3.333c.46 0 .833.373.833.834v4.166a.833.833 0 1 1-1.666 0V6.667c0-.46.373-.834.833-.834Zm0 8.334a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667Z",
    clipRule: "evenodd"
  })));
};
export default SvgWarning;